"use strict"; // https://www-doh.state.nj.us/doh-shad/view/sharedstatic/RaceAndEthnicity.pdf
// https://ir.aa.ufl.edu/surveys/race-and-ethnicity-survey/
// https://grants.nih.gov/grants/guide/notice-files/not-od-15-089.html

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHITE = exports.BLACK_OR_AFRICAN_AMERICAN = exports.NATIVE_HAWAIIAN_OR_PACIFIC_ISLANDER = exports.ASIAN = exports.AMERICAN_INDIAN_OR_ALASKA_NATIVE = exports.HISPANIC_OR_LATINO_OR_SPANISH = void 0;
exports.HISPANIC_OR_LATINO_OR_SPANISH = "hispanicOrLatinoOrSpanish";
exports.AMERICAN_INDIAN_OR_ALASKA_NATIVE = "americanIndianOrAlaskaNative";
exports.ASIAN = "asian";
exports.NATIVE_HAWAIIAN_OR_PACIFIC_ISLANDER = "nativeHawaiianOrPacificIslander";
exports.BLACK_OR_AFRICAN_AMERICAN = "blackOrAfricanAmerican";
exports.WHITE = "white";